var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.filterTags),function(tag){return _c('v-chip',{key:tag,attrs:{"close":""},on:{"input":function($event){return _vm.toggleTag(tag)}}},[_vm._v("\n    "+_vm._s(tag)+"\n  ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }